import { PARTNER_TABLE } from './type'
import * as tableAction from '../../../table/state/action'
import { selectOwnState, tableSelectorPartner } from './selector'


export const initialTableQueryPartner = tableAction.createInitialTableQueryAction(selectOwnState, PARTNER_TABLE)

export const changeFilterPartner = tableAction.createChangeFilterAction(selectOwnState, PARTNER_TABLE)

export const toggleSortPartner = tableAction.createToggleSortAction(selectOwnState, PARTNER_TABLE)

export const toggleMultiSortPartner = tableAction.createToggleMultiSortAction(selectOwnState, PARTNER_TABLE)

export const gotoPagePartner = tableAction.createGotoPageAction(PARTNER_TABLE)

export const initialTableSettings = tableAction.createInitialColumnsVisibilityTableHandler(PARTNER_TABLE)

export const toggleColumnVisibility = tableAction.createToggleColumnVisibilityTableHandler(tableSelectorPartner, PARTNER_TABLE)




// WEBPACK FOOTER //
// ./src/modules/partner/state/search/action.js